// Configuration Firebase Cloud Messaging
export const firebaseMessagingConfig = {
  // Clé VAPID pour les notifications push web
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "",

  // Configuration du service worker
  serviceWorkerPath: "/firebase-messaging-sw.js",

  // Options par défaut pour les notifications
  defaultNotificationOptions: {
    icon: "/logo192.png",
    badge: "/logo192.png",
    requireInteraction: false,
    silent: false,
  },

  // Types de notifications supportés
  notificationTypes: {
    MATCH_CREATED: "match_created",
    MATCH_STATUS_CHANGED: "match_status_changed",
    MATCH_STARTED: "match_started",
  },

  // Messages par défaut
  defaultMessages: {
    matchCreated: {
      title: "Nouveau match créé",
      body: "Un nouveau match a été créé pour un de vos joueurs suivis",
    },
    matchStatusChanged: {
      title: "Statut de match mis à jour",
      body: "Le statut d'un match a changé",
    },
    matchStarted: {
      title: "Match commencé",
      body: "Un match a commencé",
    },
  },
};
